'use client'

import React from 'react'

type Props = {
    radius: number
    cylinderHeight: number
}

const WIDTH = 340
const HEIGHT = 220

export default function CapsuleChart({ radius, cylinderHeight }: Props) {
    const maxDim = Math.max(radius * 2, cylinderHeight + radius * 2, 0.0001)
    const scale = 150 / maxDim
    const r = Math.max(radius * scale, 26)
    const h = Math.max(cylinderHeight * scale, 30)

    const cx = WIDTH / 2
    const topY = (HEIGHT - h) / 2 - 5
    const bottomY = topY + h

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            {/* body */}
            <rect x={cx - r} y={topY} width={r * 2} height={h} fill="#2563eb" opacity={0.18} />
            <line x1={cx - r} y1={topY} x2={cx - r} y2={bottomY} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx + r} y1={topY} x2={cx + r} y2={bottomY} stroke="#2563eb" strokeWidth={2} />
            {/* caps */}
            <path d={`M ${cx - r} ${topY} A ${r} ${r} 0 0 1 ${cx + r} ${topY}`} fill="#2563eb" opacity={0.25} stroke="#2563eb" strokeWidth={2} />
            <path d={`M ${cx - r} ${bottomY} A ${r} ${r} 0 0 0 ${cx + r} ${bottomY}`} fill="#2563eb" opacity={0.25} stroke="#2563eb" strokeWidth={2} />
            {/* middle ellipse to suggest cylinder */}
            <ellipse cx={cx} cy={topY} rx={r} ry={r * 0.28} fill="none" stroke="#2563eb" strokeWidth={1.2} opacity={0.5} />

            <line x1={cx} y1={topY} x2={cx + r} y2={topY} stroke="#dc2626" strokeWidth={1.5} />
            <text x={cx + r / 2} y={topY - 8} fontSize={11} textAnchor="middle" fill="#dc2626">r = {radius.toFixed(2)}</text>

            <line x1={cx - r - 16} y1={topY} x2={cx - r - 16} y2={bottomY} stroke="#16a34a" strokeWidth={1.5} />
            <text x={cx - r - 22} y={(topY + bottomY) / 2} fontSize={11} textAnchor="end" fill="#16a34a">h = {cylinderHeight.toFixed(2)}</text>
        </svg>
    )
}
